<div
  class="selected-items-list justify-content-center justify-content-lg-start justify-content-xxl-start justify-content-xl-start"
>
  <div class="single-item mb-1" *ngFor="let item of items; let i = index">
    <ng-container>
      <span>
        {{ item.value }}
      </span>
      <a (click)="removeItem(i)">
        <svg-icon
          class="remove-icon"
          src="./assets/images/icons/remove.svg"
        ></svg-icon></a
    ></ng-container>
  </div>
</div>
<ng-container
  ><app-validation
    [hidden]="!wasValidated || checkIfValid()"
    [validationMessages]="getValidationMessages()!"
  ></app-validation
></ng-container>
